import React from 'react';
import { IProps } from './types';
import _ from 'lodash';

const ActivityFlow: React.FC<IProps> = (props) => {
  /**
   * @description 格式化顯示流程文字
  */
  const handleFormatFlow = (str:string) => {
    if (str.indexOf('(') !== -1) {
      const strArray = str.split('(');

      return (
        <p>
          <>
            {strArray[0]} <br />
            {`(${strArray[1]}`}
          </>
        </p>
      );
    }

    return <p>{str}</p>;
  };

  return (
    <div className="activity-flow">
      <div className="template-container">
        <div className="template-content">
          <div className="activity-flow__title-section">
            <div className="activity-flow__title">活動流程</div>
          </div>
          <div className="activity-flow__content">
            {
              _.map(props.EVENT_FLOW, (flow: string, index: number) => {
                return (
                  <div className="activity-flow__item" key={index}>
                    <div className="activity-flow__item-container">
                      {
                        handleFormatFlow(flow)
                      }
                    </div>
                  </div>
                );
              })
            }
            {/* <div className="activity-flow__item">
              <div className="activity-flow__item-container">
                <p>1. 加入粉絲團</p>
              </div>
            </div>
            <div className="activity-flow__item">
              <div className="activity-flow__item-container">
                <p>2. 完成投保</p>
              </div>
            </div>
            <div className="activity-flow__item">
              <div className="activity-flow__item-container">
                <p>3. 推薦親友（輸入親友資料）</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityFlow;
